import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";
import api, { apiError } from "@/lib/api";
import AuthShell from "@/pages/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { LockNotice } from "@/components/LockNotice";

export default function ForgotPassword() {
  const location = useLocation();
  const [email, setEmail] = useState(location.state?.email || "");
  const [sent, setSent] = useState(false);
  const [devLink, setDevLink] = useState("");
  const [loading, setLoading] = useState(false);
  const [lockNotice, setLockNotice] = useState("");
  const { t } = useTranslation();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setLockNotice("");
    try {
      const res = await api.post("/auth/forgot-password", { email });
      if (res.data?.dev_reset_link) setDevLink(res.data.dev_reset_link);
      setSent(true);
    } catch (err) {
      if (err?.response?.status === 429) {
        setLockNotice(apiError(err, t("auth.lockedFallback")));
      } else {
        toast.error(apiError(err));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title={t("auth.forgotTitle")} subtitle={t("auth.forgotSubtitle2")}>
      {lockNotice && !sent && (
        <LockNotice message={lockNotice} ctaTo="/login" ctaLabel={t("auth.backToLogin")} />
      )}
      {sent ? (
        <div data-testid="forgot-sent" className="text-sm text-slatebody">
          {t("auth.resetSent", { email })}
          {devLink && (
            <div className="mt-4 rounded-md border border-amber-200 bg-amber-50 p-3" data-testid="dev-reset-link">
              <p className="text-xs font-medium text-amber-800">{t("auth.devMode")}</p>
              <p className="text-xs text-amber-700 mt-1">{t("auth.devEmailOff")}</p>
              <Link to={devLink} className="text-[#202123] hover:underline break-all text-xs mt-1.5 inline-block" data-testid="dev-reset-link-anchor">{t("auth.resetNow")}</Link>
            </div>
          )}
          <div className="mt-4"><Link to="/login" className="text-[#202123] hover:underline">{t("auth.backToLogin")}</Link></div>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div>
            <Label htmlFor="email">{t("auth.email")}</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" data-testid="forgot-email" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-[#ECECEC] hover:bg-[#E0E0E0] text-[#202123] border border-[#C5C5D0]" data-testid="forgot-submit">
            {loading ? t("auth.sending") : t("auth.sendReset")}
          </Button>
          <p className="text-sm text-slatebody text-center"><Link to="/login" className="text-[#202123] hover:underline">{t("auth.backToLogin")}</Link></p>
        </form>
      )}
    </AuthShell>
  );
}
